import Component from 'antd/es/time-picker';
import 'antd/lib/time-picker/style';
export default Component;
